// extracted by mini-css-extract-plugin
export var tooltipTitle = "tooltip-title__QZIZ";